import { windowIdSchema } from './selfOwnedWidget';
import type { WindowId } from './selfOwnedWidget';

/**
 * The single implicit window id used in the web bundle. Native uses one id
 * per electron `BrowserWindow`; web has only one window.
 */
export const WEB_WINDOW_ID: WindowId = windowIdSchema.parse('web');
